<template>
    <div class="row">
        <div class="d-flex col-lg-11 export-bar">
            <div class="col-lg-2">
                <div class="d-flex align-items-center">
                    <core-icon class="mr-1" iconName="Calendar" iconColor="#676767">
                        <icons-calendar></icons-calendar>
                    </core-icon>
                    <core-calendar
                        :date.sync="selectedData"
                    ></core-calendar>
                </div>
            </div>
            <div class="col-lg-2">
                <core-drop-down
                    :items="tripDirections"
                    translateLabels
                    noLabel
                ></core-drop-down>
            </div>
            <div class="col-lg-2">
                55% | 110 | 130
            </div>
            <div class="col-lg-2">
                23.000 | 40.000
            </div>
            <div class="col-lg-2 col-lg-offset-2">
                Extra's 123x
            </div>
        </div>
        <div class="d-flex col-lg-1">
            <router-link to="export">{{ $t('services.inventory.export') }}</router-link>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      selectedData: this.date,
      tripDirections: [{ name: 'services.inventory.inbound' }, { name: 'services.inventory.outbound' }]
    }
  },
  props: {
    date: {
      default: null,
      type: String,
      required: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inventory/ExportBar.vue